import React from 'react';
import { Button, withStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import {
    getOwnersProperties,
    getOwnerStripeData,
    getOwnerReservations,
} from '../../stores/dashboard/selectors';
import styles from './styles';

const ExportChartCSVButton = (props) => {
    const properties = useSelector(getOwnersProperties);
    const stripeData = useSelector(getOwnerStripeData);
    const reservationData = useSelector(getOwnerReservations);

    function exportChartViewCSV() {
        const headers = [
            'Location',
            'Gross Bookings',
            'Income',
            '# of Fuel Comps',
            'In-Store Cash Sales',
        ];
        const rows = properties.map((property) => {
            const reservations =
                reservationData?.properties[property.propertyId] || {};
            const stripe = stripeData?.properties[property.propertyId] || {};
            const grossBookings =
                (stripe.gross || 0) +
                (reservations.fuel_comp || 0) +
                (reservations.cash || 0);
            const income = stripe.revenue || 0;
            const fuelComps = reservations.fuel_comp || 0;
            const inStoreCashSales = reservations.cash || 0;
            return [
                property.propertyName || property.name || property.id,
                grossBookings,
                income,
                fuelComps,
                inStoreCashSales,
            ];
        });
        const totalRow = [
            'Total',
            rows.reduce((sum, row) => sum + row[1], 0), // Gross Bookings
            rows
                .reduce((sum, row) => parseFloat(sum) + parseFloat(row[2]), 0)
                .toFixed(2), // Income
            rows.reduce((sum, row) => sum + row[3], 0), // Fuel Comps
            rows.reduce((sum, row) => sum + row[4], 0), // In-Store Cash Sales
        ];
        rows.push(totalRow);
        const csvContent = [headers, ...rows]
            .map((row) => row.map((cell) => `"${cell}"`).join(','))
            .join('\n');
        const blob = new Blob([csvContent], {
            type: 'text/csv;charset=utf-8;',
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'owner_dashboard_chart.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    return (
        <Button
            variant="contained"
            className={props.classes.exportButtonStyle}
            onClick={exportChartViewCSV}
        >
            Export CSV
        </Button>
    );
};

export default withStyles(styles)(ExportChartCSVButton);
